import { Component } from '@angular/core';
import { ChangesTypeformPage } from './typeform/typeform';
import {RequestsPage} from "./requests/requests";


@Component({template: `
  <ion-tabs class="tabs-icon" [color]="'primary'">
    <ion-tab tabTitle="Solicitudes" tabIcon="md-git-pull-request" [root]="tab1"> </ion-tab>
    <ion-tab tabTitle="Solicitudes Typeform" tabIcon="md-at" [root]="tab2"></ion-tab>
    <!--<ion-tab tabTitle="Cambios a Futuro" tabIcon="alarm" [root]="tab3"></ion-tab>-->
  </ion-tabs>
`})
export class ChangesPage {
  tab1;
  tab2;
  tab3;
  constructor() {
    this.tab1 = RequestsPage;
    this.tab2 = ChangesTypeformPage;
    this.tab3 = ChangesTypeformPage;
  }
}



// WEBPACK FOOTER //
// ./src/pages/changes/changes.ts